import React, { useEffect, useState } from 'react';
import Organizations from './actions/Organizations';
import ChannelsMonitor from './actions/ChannelsMonitor';
import Changelog from './actions/Changelog';
import VisitorsNotification from '../../../visitors/VisitorsNotification/VisitorsNotification';
import DarkMode from './actions/DarkMode';

import { useSelector } from 'react-redux';

import { ContactCredits } from './actions/ContactCredits';

import { Credits } from './actions/Credits';

import { UserStatus } from './actions/UserStatus';
import { LanguageSelector } from './actions/LanguageSelector';

import { useFlags } from 'flagsmith/react';

function Actions() {
  /**
   * Logica Whitelabel
   */
  const wlState = useSelector((state) => state?.whitelabel);
  const hideCredits = wlState?.config?.hide_credits;
  const [isWl, setIsWl] = useState(false);
  const current_customer_id = useSelector(
    (state) => state.general?.current_customer_id
  );

  // const current_customer_id = 1;
  //
  // const mockFlags = {
  //   template_billing: {
  //     enabled: true,
  //     value: '[1]',
  //   }
  // };

  // const { template_billing } = mockFlags;
  const { template_billing } = useFlags(['template_billing']);

  const flagCustomerIds = (() => {
    if (!template_billing) return null;

    if (typeof template_billing.value === 'string') {
      try {
        const parsedValue = JSON.parse(template_billing.value || '[]');
        if (Array.isArray(parsedValue)) {
          return parsedValue.map((id) => String(id).trim());
        }
      } catch (error) {
        console.error('Erro ao processar template_billing.value:', error);
        return null;
      }
    }

    if (Array.isArray(template_billing.value)) {
      return template_billing.value.map((id) => String(id).trim());
    }

    return null;
  })();

  const canShowCreditsMenu =
    Array.isArray(flagCustomerIds) && flagCustomerIds.includes(String(current_customer_id));


  useEffect(() => {
    const _config = wlState?.config;
    const loadingWl = wlState.loading;
    const _isWl = _config?.is_white_label;

    if (!loadingWl) {
      setIsWl(_isWl);
    }
  }, [wlState]);
  /* end */

  return (
    <div className="actionsTopNav">
      {!hideCredits && !canShowCreditsMenu && <Credits />}
      <UserStatus />
      {isWl && <LanguageSelector />}
      <Organizations />

      {!isWl && (
        <>
          <ContactCredits />
          {/* <TemplateReport />  // Relatório de Templates, comentado enquanto o back é feito*/}
          <ChannelsMonitor />
          <VisitorsNotification />
          <Changelog />
          <DarkMode />
        </>
      )}
    </div>
  );
}

export default Actions;
